import { BRAND } from '../data/constants.js';
import Img from '../components/ui/Img.jsx';

const AGENT = {
  name: 'Florencia Abriola',
  role: 'Fundadora · Martillera Matriculada',
  bio: 'Con más de 34 años de trayectoria, es la cara y el corazón de Abriola Propiedades. Asesora en ventas, pozo e inversiones en Quilmes y toda la Zona Sur.',
  photo: '/abriola/florencia.png',
  whatsapp: BRAND.waVentas,
};

const VALUES = [
  ['🛡', 'Honestidad',        'Te decimos lo que necesitás saber, no lo que querés escuchar.'],
  ['✨', 'Transparencia',     'Información clara en cada operación, de principio a fin.'],
  ['👤', 'Trato personalizado','Una persona que te conoce y te acompaña en cada paso.'],
  ['⭐', 'Profesionalismo',   '34 años de experiencia y conocimiento real del mercado.'],
];

export default function About() {
  return (
    <div className="page">
      <section className="container nos-hero">
        <span className="kicker">Quiénes somos</span>
        <h1 className="nos-h1">Más de 34 años de <span className="serif-it">trayectoria</span> y confianza.</h1>
        <p className="nos-lead">Somos una inmobiliaria con más de {BRAND.years} años en el mercado, reconocida por su honestidad, transparencia, profesionalismo y trato personalizado. Ofrecemos asesoramiento con una mirada única y valiosa del mercado, y te acompañamos para encontrar la mejor alternativa que se adapte a lo que buscás.</p>
      </section>
      <section className="container">
        <div className="nos-stats">
          {[['34 años','en el mercado'],['Quilmes','y toda la Zona Sur'],['Venta · Alquiler','tasación y asesoría'],['100%','trato personalizado']].map(([n,l])=>(
            <div key={n} className="nos-stat"><b className="tnum">{n}</b><span>{l}</span></div>
          ))}
        </div>
        <div className="nos-values">
          {VALUES.map(([ic, t, d]) => (
            <div key={t} className="nos-value">
              <div className="nv-ic">{ic}</div>
              <div><b>{t}</b><p>{d}</p></div>
            </div>
          ))}
        </div>
        <h2 className="nos-h2">El equipo</h2>
        <div className="team-grid" style={{gridTemplateColumns:'360px',margin:'0 auto',justifyContent:'center'}}>
          <div className="team-card">
            <div className="team-img"><Img src={AGENT.photo} alt={AGENT.name} ratio="1" /></div>
            <div className="team-body">
              <div className="team-name">{AGENT.name}</div>
              <div className="team-role">{AGENT.role}</div>
              <p className="team-bio">{AGENT.bio}</p>
              <a className="team-wa" href={`https://wa.me/${AGENT.whatsapp}`} target="_blank" rel="noopener">💬 Escribir</a>
            </div>
          </div>
        </div>
        <div className="nos-colegio">
          <div className="nc-ic">🛡</div>
          <div>
            <span className="nc-label">Asociados con</span>
            <div className="nc-name">{BRAND.colegio}</div>
          </div>
        </div>
      </section>
    </div>
  );
}
